import React from 'react';
import { SRow } from '@avalara/skylab-sdk/react';
import ResourceTile from './resource-tile';
const Resources = ({ content }) => (React.createElement(SRow, { className: 'justify-content-center' }, content.map(({ title, textContent, buttonText, link }, i) => (React.createElement(ResourceTile, { title: title, textContent: textContent, buttonText: buttonText, link: link, key: i })))));
export default Resources;
